import angular from "angular";

angular
    .module('app')
    .component('groupLessonsControl', {
        template: require('./group-lessons-control.html'),
        controller: ['$http', 'Notifier', 'ErrorResponseParser', controller],
        bindings: {
            course: '<',
            group: '<',
            lessons: '<',
        }
    });

function controller($http, Notifier, ErrorResponseParser) {

    let $ctrl = this;

    $ctrl.search = null;

    $ctrl.$onInit = function () {
    };

    $ctrl.openLesson = function (lesson) {

        if (lesson.loading) {
            return;
        }

        lesson.loading = true;

        $http
            .post(`/admin/groups/${$ctrl.group.id}/open-lesson`, {lesson_id: lesson.id})
            .then(
                function (response) {
                    Notifier.success('Изменение сохранено', 2);
                    lesson.can_open = true;
                    lesson.loading = false;
                },
                function (error) {
                    lesson.loading = false;
                    ErrorResponseParser.parse(error);
                }
            );
    }

}
